module.exports = __webpack_public_path__ + "img/balance.94b25122.png";